module.exports = __webpack_public_path__ + "media/images/expand_icon-d5cb06ef9076c28f3f187fa4ab2caf37.png";